import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'
import Cookies from 'js-cookie'

import { ROUTER } from '../../../class/constants'
import { acPostReconnect } from '../../../class/actions'
import { LoginForm } from '../../forms'
import StartScreen from './StartScreen'

const LoginScreen = ({ isAuth, hasLoggedOut }) => {
  const location = useLocation()
  const dispatch = useDispatch()

  const pageTitle = 'Entrar'

  useEffect(() => {
    document.title = `${pageTitle} | 4KST Consulta Manager`
  }, [])

  const recoverSuccess = location.state && location.state.recoverSuccess ? true : false;

  useEffect(() => {
    const hasToken = Cookies.get('manager_tok');

    if (!hasToken)
      return;

    if (!hasLoggedOut)
      dispatch(acPostReconnect()).catch(err => console.error(err))

  }, [dispatch, hasLoggedOut])

  if (isAuth)
    return <Redirect to={{ pathname: location.state ? location.state.redirectTo : ROUTER.BLOCK }} />

  return (
    <StartScreen
      Form={LoginForm}
      recoverSuccess={recoverSuccess}
      width="600px"
    >
    </StartScreen>
  )
}

const mapStateToProps = state => ({
  isAuth: state.ReducerAuth.isAuth,
  hasLoggedOut: state.ReducerAuth.hasLoggedOut
})

export default connect(mapStateToProps)(LoginScreen)